import i18next from "i18next";
import * as yup from "yup";

export function validation(coverUrl) {
  return yup.object().shape({
    comment:
      coverUrl !== undefined
        ? yup
            .string()
            .min(3, "Minimum 3 Character required")
            .trim(i18next.t("validation.common.noSpace"))
            .required("Comment is required")
        : yup
            .string()
            .min(3, "Minimum 3 Character required")
            .trim(i18next.t("validation.common.noSpace")),
    filePath: yup.string().optional(),
  });
}
